import {useNavigate, useSearchParams} from "react-router-dom";
import {useGetWellQuery, wellSelector} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo} from "react";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {WellProfile} from "../../components/profile/WellProfile/WellProfile"
import {useTranslation} from "react-i18next";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const WellProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const id = params.get("id") ?? undefined;

  const {t} = useTranslation(["common"])

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.well", "Well") + " " + t("common.error.notfound", "Not Found")}
      />
    );
  }

  return <WellProfilePage id={id}/>;
};

export const WellProfilePage = (props: Props) => {
  const {id} = props;

  const selectWell = useMemo(() => {
    return wellSelector()
  }, []);

  const {well, isFetching} = useGetWellQuery(id ?? skipToken, {
    selectFromResult: (result) => ({
      well: selectWell(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage entity={well} isLoading={isFetching} permissions={["well_view"]}>
      {(entity) => (
        <WellProfile well={entity}/>
      )}
    </EntityProfilePage>
  )
};
